import { createContext } from "react";

const configGameContext = createContext({})

export default configGameContext